var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstallmentsTerciary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.003 1.883a1.714 1.714 0 1 0 0 3.428c9.466 0 17.14 7.674 17.14 17.14 0 8.657-6.417 15.815-14.754 16.976l2.014-2.014a1.714 1.714 0 1 0-2.424-2.424l-4.724 4.724c-.67.67-.67 1.755 0 2.425l4.724 4.724a1.714 1.714 0 1 0 2.424-2.424l-1.605-1.606c10.038-1.364 17.773-9.968 17.773-20.38 0-11.36-9.209-20.57-20.568-20.57"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.983 24.475a1.714 1.714 0 1 0-3.405.4c.279 2.364.967 4.69 2.067 6.865a1.714 1.714 0 1 0 3.06-1.548 17.1 17.1 0 0 1-1.722-5.718"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.674 11.06a1.714 1.714 0 0 1 .556 2.36 17.1 17.1 0 0 0-2.21 5.548 1.714 1.714 0 1 1-3.358-.692 20.5 20.5 0 0 1 2.652-6.66 1.714 1.714 0 0 1 2.36-.555"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.963 6.316a1.714 1.714 0 1 0-1.167-3.224 20.5 20.5 0 0 0-6.211 3.579 1.714 1.714 0 1 0 2.205 2.625 17.1 17.1 0 0 1 5.173-2.98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.601 34.287a1.714 1.714 0 0 0-2.483 2.364 20.5 20.5 0 0 0 5.772 4.25 1.714 1.714 0 0 0 1.519-3.074 17.1 17.1 0 0 1-4.808-3.54"
}))));
export default SvgInstallmentsTerciary;